import "./Alert.css";
import React from "react";
import PropTypes from "prop-types";
import { MDBAlert } from "mdbreact";


const Component = ({ alert: { message, type } }) => (
      <div className="Alert">
            {message && (
                  <MDBAlert color="primary" bsstyle={type}  >
                        {message}
                  </MDBAlert>
            )}
      </div>
);

Component.propTypes = {
      alert: PropTypes.shape({
            type: PropTypes.string,
            message: PropTypes.string
      }).isRequired,
      silence: PropTypes.func.isRequired
};

export default Component;
